// src/services/deviceService.jsx
import http from "./http";

/* --------------------------------
   GET MY DEVICES
   GET /api/school/my_devices.php or /my-devices
-------------------------------- */
export const getMyDevices = async () => {
  try {
    const res = await http.get("my_devices.php");
    return res.data;
  } catch (error) {
    try {
      const fallback = await http.get("my-devices");
      return fallback.data;
    } catch (err) {
      return error?.response?.data || { status: false, message: "Network Error: Could not fetch devices" };
    }
  }
};
